import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SimulationProvider } from "@/context/SimulationContext";
import Header from "@/components/Layout/Header";
import Footer from "@/components/Layout/Footer";
import Beranda from "@/pages/Beranda";
import PltsTumbuh from "@/pages/PltsTumbuh";
import Simulasi from "@/pages/Simulasi";
import Konfigurator from "@/pages/Konfigurator";
import RencanaTumbuh from "@/pages/RencanaTumbuh";
import Proyek from "@/pages/Proyek";
import Insight from "@/pages/Insight";
import Mitra from "@/pages/Mitra";
import Tentang from "@/pages/Tentang";
import Kontak from "@/pages/Kontak";
import Privasi from "@/pages/Privasi";

export default function App() {
  return (
    <BrowserRouter>
      <SimulationProvider>
        <div className="min-h-screen flex flex-col bg-white">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Beranda />} />
              <Route path="/plts-tumbuh" element={<PltsTumbuh />} />
              <Route path="/simulasi" element={<Simulasi />} />
              <Route path="/konfigurator" element={<Konfigurator />} />
              <Route path="/rencana-tumbuh" element={<RencanaTumbuh />} />
              <Route path="/proyek" element={<Proyek />} />
              <Route path="/insight" element={<Insight />} />
              <Route path="/mitra" element={<Mitra />} />
              <Route path="/tentang" element={<Tentang />} />
              <Route path="/kontak" element={<Kontak />} />
              <Route path="/privasi" element={<Privasi />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
        </div>
      </SimulationProvider>
    </BrowserRouter>
  );
}
